export const frStats = {
    'stats.tab.label': 'STATS',
    'stats.since': 'DEPUIS LE {since}',
    'stats.reached_count':
        'Soit {reached_count} {reached_count, plural, =0 {centres actifs} one {centre actif} other {centres actifs}}',
    'stats.legend.title': 'Légende',
    'stats.tooltip.since': 'Depuis la publication',

    'stats.legend.reminder_sent': 'Jour de relance',
    'stats.legend.is_publish': 'Date de publication',
    'stats.legend.is_end': "Date d'échéance",

    // OPENINGS

    'stats.tab.openings.section.title': 'OUVERTURES',
    'stats.openings.reached_percentage': "% d'ouvertures",
    'stats.openings.title': 'OUVERTURES DE CE CONTENU',
    'stats.openings.subtitle': '1ères ouvertures, relectures, taux',

    'stats.openings.chart.opening_count': 'Nbre de lectures',
    'stats.openings.chart.cumulative_first_opening_rate': '% des centres',
    'stats.openings.chart.cumulative_first_opening_rate.users': '% des utilisateurs',
    'stats.openings.legend.cumulative_first_opening_rate_format': '{value}%',

    'stats.openings.legend.daily_first_opening_count': '1ères ouvertures par jour',
    'stats.openings.legend.daily_reopening_count': 'Nbre de relectures du jour',
    'stats.openings.legend.cumulative_opening_rate': 'Taux d’ouverture',

    'stats.openings.tooltip.date': 'Le {date}',
    'stats.openings.tooltip.daily_first_openings_count':
        '1ères ouvertures : {dailyFirstOpeningsCount} ({dailyFirstOpeningsRate}%)',
    'stats.openings.tooltip.daily_reopenings_count':
        'Nbre de relectures du jour : {dailyReopeningsCount}',
    'stats.openings.tooltip.daily_cumulative_openings_rate':
        'Taux d’ouvertures cumulées : {dailyCumulativeOpeningsRate}%',
    'stats.openings.tooltip.daily_opening_count':
        'Nbre total lectures du jour : {dailyOpeningCount}',
    'stats.openings.tooltip.cumulative_first_opening_count':
        'Total 1ères ouvertures : {cumulativeFirstOpeningCount}',

    // REPLIES
    'stats.tab.replies.section.title': 'RÉPONSES',
    'stats.replies.reached_percentage': '% de réponses',
    'stats.replies.title': 'RÉPONSES SUR CE CONTENU',
    'stats.replies.subtitle': 'Nombre de réponses et taux',

    'stats.replies.chart.replies_count': 'Nbre de réponses',
    'stats.replies.chart.cumulative_replies_rate': '% des centres',
    'stats.replies.chart.cumulative_replies_rate.users': '% des utilisateurs',
    'stats.replies.legend.cumulative_replies_rate_format': '{value}%',

    'stats.replies.legend.daily_replies_count': 'Nbre total de réponse du jour',
    'stats.replies.legend.cumulative_replies_rate': 'Taux de réponses',

    'stats.replies.tooltip.date': 'Le {date}',
    'stats.replies.tooltip.daily_replies_count':
        'Nbre total réponses du jour : {dailyRepliesCount}',
    'stats.replies.tooltip.daily_cumulative_replies_rate':
        'Taux de réponses cumulées : {dailyCumulativeRepliesRate}%',

    'stats.replies.tooltip.cumulative_replies_count':
        'Total de réponses : {cumulativeRepliesCount}',

    //MULTI REPLIES : (ex: commandes chez midas) // TODO rendre générique ou configurable

    'stats.tab.multi_replies.section.title': 'COMMANDES',
    'stats.multi_replies.reached_percentage': '% de commandes',
    'stats.multi_replies.title': 'COMMANDES DE CE CONTENU',
    'stats.multi_replies.subtitle': '1ères commandes, commandes supplémentaires, taux',

    'stats.multi_replies.chart.replies_count': 'Nbre de commandes',
    'stats.multi_replies.chart.cumulative_first_replies_rate': '% des centres',
    'stats.multi_replies.chart.cumulative_first_replies_rate.users': '% des utilisateurs',
    'stats.multi_replies.legend.cumulative_first_replies_rate_format': '{value}%',

    'stats.multi_replies.legend.daily_first_replies_count': '1ères commandes par jour',
    'stats.multi_replies.legend.daily_rereplies_count': 'Nbre de commandes supplémentaires du jour',
    'stats.multi_replies.legend.cumulative_replies_rate': 'Taux de commandes',

    'stats.multi_replies.tooltip.date': 'Le {date}',
    'stats.multi_replies.tooltip.daily_first_replies_count':
        '1ères commandes : {dailyFirstRepliesCount} ({dailyFirstRepliesRate}%)',
    'stats.multi_replies.tooltip.daily_rereplies_count':
        'Nbre de commandes supplémentaires du jour : {dailyRerepliesCount}',
    'stats.multi_replies.tooltip.daily_cumulative_replies_rate':
        'Taux de 1ères commandes cumulées : {dailyCumulativeRepliesRate}%',
    'stats.multi_replies.tooltip.daily_replies_count':
        'Nbre total de commandes du jour : {dailyRepliesCount}',
    'stats.multi_replies.tooltip.cumulative_first_replies_count':
        'Total 1ères commandes : {cumulativeFirstRepliesCount}',

    //ERROR NO CONTENT

    'stats.content.unavailable.unpublished':
        "Ce contenu ne possède pas de statistiques car il n'est pas encore publié",

    'stats.load.error': "Les statistiques n'ont pas pu être chargées. Veuillez réessayer",

    // PERMISSIONS
    'backofficeUsers.create.tabs.permissions.toggles.statsread': 'Lire les stats',
    'backofficeUsers.create.tabs.permissions.toggles.statsexport': 'Exporter les stats',

    // GENERAL STATS

    'stats.list.title': 'Stats',
    'stats.list.pageTitle': 'Statistiques',
    'stats.list.error': 'Erreur de chargement. Veuillez réessayer',

    // GENERAL STATS > CONNECTION RATES

    'stats.list.connection_rates.title': 'Taux de connexion',
    'stats.list.connection_rates.item.label': '% connexion',
    'stats.list.connection_rates.item.subtitle':
        'Soit {value} {value, plural, =0 {centres} one {centre} other {centres}}',
    'stats.list.connection_rates.item.this_week': '7 DERNIERS JOURS',
    'stats.list.connection_rates.item.this_month': '30 DERNIERS JOURS',
    'stats.list.connection_rates.item.this_year': '12 DERNIERS MOIS',
    'stats.list.connection_rates.item.since_launch': 'DEPUIS LE LANCEMENT',

    'stats.list.export': 'Export Excel',
};
